module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921002649_T.9ad86712.jpg";